import _Segmented from './Segmented';
import './style/index.js';

export type { SegmentedProps } from './Segmented';
export * from './type';

export const Segmented = _Segmented;
export default Segmented;
